import { FC } from "react";
import styled, { keyframes } from "styled-components";
import { theme } from "../../Customization/Theme";

interface LinearLoaderProps {
  $position?: "absolute" | "relative";
}

const LinearLoader:FC<LinearLoaderProps> = ({ $position = "absolute" }) => {
  return (
    <StyledFullPageBox $position={$position}>
      <StyledLinearLoader />
    </StyledFullPageBox>
  );
};

export default LinearLoader;

const StyledFullPageBox = styled.div`
  && {
    width: 100%;
    height: 100%;
    position: ${(props: { $position: string }) =>
      props?.$position ?? "absolute"};
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 1);
    z-index: 99;
  }
`;

const moving = keyframes`
  50% {
    width: 100%;
  }
  100% {
    width: 0;
    right: 0;
    left: unset;
  }
`;

const StyledLinearLoader = styled.div`
  display: block;
  --height-of-loader: 4px;
  --loader-color: ${({ theme }: any) => theme.palette.primary.main};
  width: 130px;
  height: var(--height-of-loader);
  border-radius: 30px;
  background-color: rgba(0, 0, 0, 0.2);
  position: relative;

  &::before {
    content: "";
    position: absolute;
    background: var(--loader-color);
    top: 0;
    left: 0;
    width: 0%;
    height: 100%;
    border-radius: 30px;
    animation: ${moving} 1s ease-in-out infinite;
  }
`;
